var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2023 Félix Robles <felix@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { createContext, useContext, useEffect, useState, } from "react";
import { useMutation } from "@apollo/client";
import { v4 } from "uuid";
import { useGetOne, useNotify, useRefresh, useGetList } from "react-admin";
import { useTranslation } from "react-i18next";
import { isNull } from "@sequentech/ui-core";
import { useNavigate } from "react-router-dom";
import { useTreeMenuData } from "@/components/menu/items/use-tree-menu-hook";
import { NewResourceContext } from "@/providers/NewResourceProvider";
import { SettingsContext } from "@/providers/SettingsContextProvider";
import { useWidgetStore } from "@/providers/WidgetsContextProvider";
import { IMPORT_ELECTION_EVENT } from "@/queries/ImportElectionEvent";
import { addDefaultTranslationsToElement } from "@/services/i18n";
import { ETasksExecution } from "@/types/tasksExecution";
import { INSERT_ELECTION_EVENT } from "@/queries/InsertElectionEvent";
import { useTenantStore } from "./TenantContextProvider";
import { useAtom } from "jotai";
import archivedElectionEventSelection from "@/atoms/archived-election-event-selection";
var PullChecker = function (_a) {
    var id = _a.id, resource = _a.resource, dependencies = _a.dependencies, onResolved = _a.onResolved;
    var globalSettings = useContext(SettingsContext).globalSettings;
    var _b = useGetList(resource, { filter: { id: id } }, {
        refetchInterval: globalSettings.QUERY_POLL_INTERVAL_MS,
    }), data = _b.data, isLoading = _b.isLoading, error = _b.error;
    useEffect(function () {
        onResolved({ data: data, isLoading: isLoading, error: error });
    }, __spreadArray([isLoading, data, error, id], dependencies, true));
    return _jsx("div", {});
};
var CreateElectionEventContext = createContext({
    createDrawer: false,
    importDrawer: false,
    postDefaultValues: console.log,
    handleElectionCreated: console.log,
    uploadCallback: console.log,
    handleImportElectionEvent: console.log,
    handleSubmit: console.log,
    openCreateDrawer: console.log,
    closeCreateDrawer: console.log,
    openImportDrawer: console.log,
    closeImportDrawer: console.log,
    errors: null,
    isLoading: false,
    newId: false,
    tenantId: "",
});
export var CreateElectionEventProvider = function (_a) {
    var children = _a.children;
    var _b = useState(false), createDrawer = _b[0], toggleCreateDrawer = _b[1];
    var _c = useState(false), importDrawer = _c[0], toggleImportDrawer = _c[1];
    var insertElectionEvent = useMutation(INSERT_ELECTION_EVENT)[0];
    var tenantId = useTenantStore()[0];
    var globalSettings = useContext(SettingsContext).globalSettings;
    var notify = useNotify();
    var _d = useState(null), newId = _d[0], setNewId = _d[1];
    var _e = useState(false), isLoading = _e[0], setIsLoading = _e[1];
    var _f = useState(), settings = _f[0], setSettings = _f[1];
    var t = useTranslation().t;
    var navigate = useNavigate();
    var refresh = useRefresh();
    var _g = useWidgetStore(), addWidget = _g[0], setWidgetTaskId = _g[1], updateWidgetFail = _g[2];
    var setLastCreatedResource = useContext(NewResourceContext).setLastCreatedResource;
    var refetchTreeMenu = useTreeMenuData(false).refetch;
    var _h = useAtom(archivedElectionEventSelection), isArchivedElectionEvents = _h[0], setArchivedElectionEvents = _h[1];
    var postDefaultValues = function () { return ({ id: v4() }); };
    var tenant = useGetOne("sequent_backend_tenant", {
        id: tenantId,
    }).data;
    var openCreateDrawer = function () {
        setIsLoading(false);
        toggleCreateDrawer(true);
    };
    var closeCreateDrawer = function () {
        toggleCreateDrawer(false);
    };
    var openImportDrawer = function () {
        setErrors(null);
        toggleImportDrawer(true);
    };
    var closeImportDrawer = function () {
        toggleImportDrawer(false);
    };
    useEffect(function () {
        if (tenant) {
            var temp = tenant === null || tenant === void 0 ? void 0 : tenant.settings;
            setSettings(temp);
        }
    }, [tenant]);
    var handleElectionCreated = function (_a) {
        var error = _a.error, isOneLoading = _a.isLoading, newElectionEvent = _a.data;
        if (isNull(newId)) {
            setIsLoading(false);
            return;
        }
        if (isLoading && error && !isOneLoading) {
            setIsLoading(false);
            notify(t("electionEventScreen.createElectionEventError"), { type: "error" });
            refresh();
            return;
        }
        if (isLoading && !error && !isOneLoading && newElectionEvent.length) {
            setIsLoading(false);
            notify(t("electionEventScreen.createElectionEventSuccess"), { type: "success" });
            refresh();
            navigate("/sequent_backend_election_event/".concat(newId));
        }
    };
    var handleSubmit = function (values) { return __awaiter(void 0, void 0, void 0, function () {
        var currWidget, electionSubmit, i18n, tenantLangConf, presentation, _a, data, errors_1, newId_1, error_1;
        var _b, _c, _d, _e, _f, _g, _h, _j;
        return __generator(this, function (_k) {
            switch (_k.label) {
                case 0:
                    currWidget = addWidget(ETasksExecution.CREATE_ELECTION_EVENT, undefined);
                    electionSubmit = values;
                    i18n = addDefaultTranslationsToElement(electionSubmit);
                    tenantLangConf = (_c = (_b = tenant === null || tenant === void 0 ? void 0 : tenant.settings) === null || _b === void 0 ? void 0 : _b.language_conf) !== null && _c !== void 0 ? _c : {
                        enabled_language_codes: (_d = settings === null || settings === void 0 ? void 0 : settings.languages) !== null && _d !== void 0 ? _d : ["en"],
                        default_language_code: "en",
                    };
                    tenantLangConf.default_language_code = (_e = tenantLangConf.default_language_code) !== null && _e !== void 0 ? _e : "en";
                    presentation = __assign(__assign({}, values.presentation), { i18n: i18n, language_conf: tenantLangConf });
                    electionSubmit = __assign(__assign({}, electionSubmit), { presentation: presentation });
                    closeCreateDrawer();
                    _k.label = 1;
                case 1:
                    _k.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, insertElectionEvent({
                            variables: {
                                electionEvent: electionSubmit,
                            },
                        })];
                case 2:
                    _a = _k.sent(), data = _a.data, errors_1 = _a.errors;
                    newId_1 = (_g = (_f = data === null || data === void 0 ? void 0 : data.insertElectionEvent) === null || _f === void 0 ? void 0 : _f.id) !== null && _g !== void 0 ? _g : null;
                    if (newId_1) {
                        setNewId(newId_1);
                        setWidgetTaskId(currWidget.identifier, (_j = (_h = data === null || data === void 0 ? void 0 : data.insertElectionEvent) === null || _h === void 0 ? void 0 : _h.task_execution) === null || _j === void 0 ? void 0 : _j.id, function () { return navigate("/sequent_backend_election_event/".concat(newId_1)); });
                        setLastCreatedResource({ id: newId_1, type: "sequent_backend_election_event" });
                        setIsLoading(true);
                    }
                    else {
                        updateWidgetFail(currWidget.identifier);
                        setIsLoading(false);
                    }
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _k.sent();
                    setIsLoading(false);
                    updateWidgetFail(currWidget.identifier);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var _j = useState(null), errors = _j[0], setErrors = _j[1];
    var importElectionEvent = useMutation(IMPORT_ELECTION_EVENT)[0];
    // const closeImportDrawer = () => {
    //     toggleImportDrawer((prev) => !prev)
    //     setErrors(null)
    // }
    var uploadCallback = function (documentId, password) {
        if (password === void 0) { password = ""; }
        return __awaiter(void 0, void 0, void 0, function () {
            var _a, importData, errors;
            var _b, _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        setErrors(null);
                        return [4 /*yield*/, importElectionEvent({
                                variables: {
                                    tenantId: tenantId,
                                    documentId: documentId,
                                    password: password,
                                    checkOnly: true,
                                },
                            })];
                    case 1:
                        _a = _d.sent(), importData = _a.data, errors = _a.errors;
                        if ((_b = importData === null || importData === void 0 ? void 0 : importData.import_election_event) === null || _b === void 0 ? void 0 : _b.error) {
                            setErrors(importData.import_election_event.error);
                            throw new Error((_c = importData === null || importData === void 0 ? void 0 : importData.import_election_event) === null || _c === void 0 ? void 0 : _c.error);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    var handleImportElectionEvent = function (documentId, sha256, password) { return __awaiter(void 0, void 0, void 0, function () {
        var currWidget, _a, data, errors_2, id_1, err_1;
        var _b, _c, _d, _e;
        return __generator(this, function (_f) {
            switch (_f.label) {
                case 0:
                    closeImportDrawer();
                    setIsLoading(false);
                    setErrors(null);
                    currWidget = addWidget(ETasksExecution.IMPORT_ELECTION_EVENT, undefined);
                    _f.label = 1;
                case 1:
                    _f.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, importElectionEvent({
                            variables: {
                                tenantId: tenantId,
                                documentId: documentId,
                                password: password,
                            },
                        })];
                case 2:
                    _a = _f.sent(), data = _a.data, errors_2 = _a.errors;
                    if ((_b = data === null || data === void 0 ? void 0 : data.import_election_event) === null || _b === void 0 ? void 0 : _b.error) {
                        setErrors(data.import_election_event.error);
                        updateWidgetFail(currWidget.identifier);
                        return [2 /*return*/];
                    }
                    id_1 = (_c = data === null || data === void 0 ? void 0 : data.import_election_event) === null || _c === void 0 ? void 0 : _c.id;
                    if (id_1) {
                        setWidgetTaskId(currWidget.identifier, (_e = (_d = data === null || data === void 0 ? void 0 : data.import_election_event) === null || _d === void 0 ? void 0 : _d.task_execution) === null || _e === void 0 ? void 0 : _e.id, function () { return navigate("/sequent_backend_election_event/".concat(id_1)); });
                        setNewId(id_1);
                        setLastCreatedResource({ id: id_1, type: "sequent_backend_election_event" });
                        setArchivedElectionEvents(false);
                    }
                    return [3 /*break*/, 4];
                case 3:
                    err_1 = _f.sent();
                    updateWidgetFail(currWidget.identifier);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    return (_jsx(CreateElectionEventContext.Provider, __assign({ value: {
            createDrawer: createDrawer,
            importDrawer: importDrawer,
            openCreateDrawer: openCreateDrawer,
            closeCreateDrawer: closeCreateDrawer,
            openImportDrawer: openImportDrawer,
            closeImportDrawer: closeImportDrawer,
            postDefaultValues: postDefaultValues,
            handleElectionCreated: handleElectionCreated,
            uploadCallback: uploadCallback,
            handleImportElectionEvent: handleImportElectionEvent,
            handleSubmit: handleSubmit,
            errors: errors,
            isLoading: isLoading,
            newId: newId,
            tenantId: tenantId,
        } }, { children: children })));
};
//hook
export var useCreateElectionEventStore = function () { return useContext(CreateElectionEventContext); };
